
import { reactive, defineComponent, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import ApiPokemon from "@/core/ApiPokemon.ts";
import { PokeGeneration } from "@/store/interfaces";
import GenerationPokemons from "@/components/Generation/GenerationPokemons.vue";
import router from "@/router";

export default defineComponent({
  components: { GenerationPokemons },
  name: "Generation",
  setup() {
    const route = useRoute();

    interface Generation {
      generation: Array<PokeGeneration>;
      generationSelected: string;
      retornoGeneration: PokeGeneration;
      retornou: boolean;
      msg: string;
      carregado: boolean;
      error: boolean;
    }
    const state = reactive({
      generation: [] as Array<PokeGeneration>,
      generationSelected: "",
      retornoGeneration: {} as PokeGeneration,
      retornou: false,
      msg: "Search a generation.",
      carregado: false,
      error: false,
    }) as Generation;

    async function retornaGenerations() {
      const request = new ApiPokemon();

      await request
        .getGenerations()
        .then(response => {
          state.generation = response; // remove shadow e unknown
          //state.carregado = true;
        })
        .catch(err => {
          console.log(err);
        });
    }

    async function retornaGeneration(id: string) {
      const request = new ApiPokemon();

      await request
        .getGeneration(id, "generation")
        .then(response => {
          if (Object.keys(response).length == 0) {
            state.carregado = false;
            state.msg = "";
            state.retornou = false;
            state.error = true;
          } else {
            state.retornoGeneration = response;
            state.msg = "";
            state.retornou = true;
            state.carregado = true;
          }
        })
        .catch(() => {
          state.carregado = false;
          state.msg = "";
          state.retornou = false;
          state.error = true;
        });
    }

    function reset() {
      state.generation = [] as Array<PokeGeneration>;
      state.generationSelected = "";
      state.retornoGeneration = {} as PokeGeneration;
      state.retornou = false;
      state.msg = "Search a generation.";
      state.carregado = false;
    }

    function setaGeneration(id: string) {
      router.push({ name: "PokemonGeneration", params: { id: id } });
    }

    onMounted(() => {
      // ...
      if (typeof route.params.id !== "undefined") {
        reset();
        state.generationSelected = route.params.id.toString();
        retornaGeneration(route.params.id.toString());
      } else {
        reset();
      }
      retornaGenerations();
    });

    // watch(
    //   () => state.generationSelected,
    //   () => {
    //     state.carregado = false;
    //     state.retornoGeneration = {} as PokeGeneration;
    //     state.retornou = false;
    //     state.msg = "Search for a generation.";
    //     retornaGeneration(state.generationSelected + 1);
    //   }
    // );
    watch(
      () => route.params,
      async () => {
        state.carregado = false;
        if (typeof route.params.id !== "undefined") {
          reset();
          state.generationSelected = route.params.id.toString();
          retornaGeneration(route.params.id.toString());
        } else {
          reset();
        }
        retornaGenerations();
      }
    );

    return {
      route,
      state,
      retornaGeneration,
      retornaGenerations,
      setaGeneration,
      reset,
    };
  },
});
